import {PODCorrectionsRow} from "./PODCorrectionsRow";
import {DeliveryPreferentialOriginDocument, LinkDeliveryPreferentialOriginDocumentInput} from "../../graphql/pod/generated/api";
import {User} from "../../graphql/graphql";

export function mapToRow(document: DeliveryPreferentialOriginDocument): PODCorrectionsRow {
    return {
        id: document.id || '',
        deliveryNoteNumber: document.delivery?.deliveryNoteNumber || '',
        productCode: document.delivery?.productCode || '',
        purchaseOrderNumber: document.delivery?.purchaseOrderNumber || '',
        purchaseOrderLineNumber: document.delivery?.purchaseOrderLineNumber || '',
        factoryCommercialInvoiceNumber: document.delivery?.factoryCommercialInvoiceNumber || '',
        transportEquipmentNumber: document.delivery?.transportEquipmentNumber || '',
        materialCountryOfOrigin: document.delivery?.materialCountryOfOrigin || '',

        podNumber: document.preferentialOriginDocument?.number || '',
        quantity: document.preferentialOriginDocument?.quantity || 0,
        destinationCountry: document.preferentialOriginDocument?.destinationCountry || '',
        stpQualifier: document.preferentialOriginDocument?.stpQualifier || '',
        stpCode: document.preferentialOriginDocument?.stpCode || '',
        stpCodeMasterData: document.preferentialOriginDocument?.stpCodeMasterData || '',

        newPodNumber: '',
        newDestinationCountry: '',
        newStpCode: '',

        toBeDeleted: false,
    }
}

export function mapToMutationRecord(row: PODCorrectionsRow, user: User | undefined): LinkDeliveryPreferentialOriginDocumentInput {

    return {
        id: row.id,
        delivery: {
            productCode: row.productCode,
            factoryCommercialInvoiceNumber: row.factoryCommercialInvoiceNumber,
            transportEquipmentNumber: row.transportEquipmentNumber,
        },
        preferentialOriginDocument: {
            number: row.toBeDeleted ? '' : (row.newPodNumber || row.podNumber),
            destinationCountry: row.toBeDeleted ? '' : (row.newDestinationCountry || row.destinationCountry),
            stpCode: row.toBeDeleted ? '' : (row.newStpCode || row.stpCode),
        },
        author: user?.name || 'unknown',
    }
}